module.exports = __webpack_public_path__ + "static/media/stationary.5d7fe80f.jpg";